module Eseebase {
    export interface IMapPinScope extends ng.IScope {
        ngModel: FileModel;
        faces: GeometryFace[];
        loadOrganizations: Function;
        associationLoading: boolean;
        associations: OrganizationalUnitViewModel[];
        departments: OrganizationalUnitViewModel[];
        selectedAssociation: OrganizationalUnitViewModel;
        showAssociationName: Function;
    }

    export class MapPinDirective {
        public link: (scope: IMapPinScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/map-pin.html';
        public scope = {
            ngModel: '=',
        };
        public require: string;

        constructor(private fileService: FileService, private $sce: ng.ISCEService, private organizationService: OrganizationService, private organizationSettingsService: OrganizationSettingsService)
        {
            var vm = this;
            MapPinDirective.prototype.require = '?ngModel';
            MapPinDirective.prototype.link = (scope: IMapPinScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                var vm = this;
                var getBoundaryBox = function (faces: GeometryFace[]) {
                    var result = new BoundaryBox();
                    for (var f of faces) {
                        for (var v of f.vertices) {
                            if (v.x < result.min.x) {
                                result.min.x = v.x;
                            }
                            if (v.x > result.max.x) {
                                result.max.x = v.x;
                            }

                            if (v.y < result.min.y) {
                                result.min.y = v.y;
                            }
                            if (v.y > result.max.y) {
                                result.max.y = v.y;
                            }

                            if (v.z < result.min.z) {
                                result.min.z = v.z;
                            }
                            if (v.z > result.max.z) {
                                result.max.z = v.z;
                            }
                        }
                    }
                    return result;
                };
                function maxZ(vertices: Point3[]) {
                    var tmp = Number.MIN_VALUE;
                    for (var i = 0; i < vertices.length; i++) {
                        if (vertices[i].z > tmp) {
                            tmp = vertices[i].z;
                        }
                    }
                    return tmp;
                }
                function minY(vertices: Point3[]) {
                    var tmp = Number.MAX_VALUE;
                    for (var i = 0; i < vertices.length; i++) {
                        if (vertices[i].y < tmp) {
                            tmp = vertices[i].y;
                        }
                    }
                    return tmp;
                }
                function orderFaces(faces: GeometryFace[]) {
                    return faces.sort((a: GeometryFace, b: GeometryFace) => (minY(a.vertices) > minY(b.vertices) ? 1 : -1));
                }
                var project = (vertice: Point3) => new Point2(vertice.x, vertice.z);
                var render = function (dx: number, dy: number, scale: number, centerX: number, centerY: number) {
                    if (scope.faces == null) {
                        return;
                    }
                    var svg = '';
                    var levels = [];
                    var colors = ['rgba(0, 205, 175, 1)', 'rgba(125, 125, 175, 1)', 'rgba(205, 0, 125, 1)', 'rgba(0, 125, 205, 1)'];
                    for (let i = 0, ii = scope.faces.length; i < ii; i++) {
                        let face = scope.faces[i];
                        if (face.vertices != null && face.vertices.length > 0) {
                            var levelId = levels.indexOf(face.levelId);
                            if (levelId == -1) {
                                levels.push(face.levelId);
                                levelId = levels.length - 1;
                            }
                            if (levelId > colors.length - 1) {
                                levelId = colors.length - 1;
                            }
                            let point = project(face.vertices[0]);
                            var str = `<path d="M${scale * (point.x - centerX) + dx} ${-scale * (point.y - centerY) + dy}`;
                            for (let o = 1, oo = face.vertices.length; o < oo; o++) {
                                point = project(face.vertices[o]);
                                str += ` L ${scale * (point.x - centerX) + dx} ${-scale * (point.y - centerY) + dy}`;
                            }
                            str += ` Z" fill="${colors[levelId]}" stroke="rgba(0, 0, 0, .5)" stroke-linecap=\"round\" stroke-linejoin=\"round\" />`;
                            svg += str;
                        }
                    }
                    $('.map-pin svg').parent().css('display', 'inline-block');
                    $('.map-pin svg').html(svg);
                };
                var rotate = function (vertice: Point3, center: Point3, theta: number, phi: number) {
                    var ct = Math.cos(theta),
                        st = Math.sin(theta),
                        cp = Math.cos(phi),
                        sp = Math.sin(phi),

                        x = vertice.x - center.x,
                        y = vertice.y - center.y,
                        z = vertice.z - center.z;

                    vertice.x = ct * x - st * cp * y + st * sp * z + center.x;
                    vertice.y = st * x + ct * cp * y - ct * sp * z + center.y;
                    vertice.z = sp * y + cp * z + center.z;
                };
                //scope.$watch('ngModel', (newVal: any, oldVal: any, sc: any) => {
                //    if (newVal != null && newVal.id != null) {
                //        $('.map-pin svg').parent().css('display', 'none');
                //        this.fileService.getOutdoorGeometry(newVal.id).then((faces: GeometryFace[]) => {
                //            scope.faces = faces;
                //            scope.faces = orderFaces(scope.faces);
                //            var box = getBoundaryBox(faces);
                //            var width = 300; //Math.abs(box.Max.X - box.Min.X);
                //            var height = 200; //Math.abs(box.Max.Z - box.Min.Z);
                //            var center = new Point3(box.min.x + (Math.abs(box.max.x - box.min.x)) / 2, box.min.y + (Math.abs(box.max.y - box.min.y)) / 2, box.min.z + (Math.abs(box.max.z - box.min.z)) / 2);
                //            var scale = Math.min(width / Math.abs(box.max.x - box.min.x), height / Math.abs(box.max.z - box.min.z));
                //            var dx = width / 2;
                //            var dy = height / 2;
                //            for (var i = 0; i < scope.faces.length; i++) {
                //                for (var j = 0; j < scope.faces[i].vertices.length; j++) {
                //                    rotate(scope.faces[i].vertices[j], center, Math.PI / 12, 0);
                //                }
                //            }
                //            for (var i = 0; i < scope.faces.length; i++) {
                //                for (var j = 0; j < scope.faces[i].vertices.length; j++) {
                //                    rotate(scope.faces[i].vertices[j], center, 0, -Math.PI / 12);
                //                }
                //            }
                //            render(dx, dy, scale, center.x, center.z);
                //        });
                //    }
                //});

                scope.showAssociationName = function (): boolean {
                    if (organizationSettingsService.uiStyling != null)
                    {
                        return organizationSettingsService.uiStyling.mapPinShowAssociationName();
                    }
                    return false;
                }
                
                scope.loadOrganizations = function () {
                    scope.associationLoading = true;
                    organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                        scope.associationLoading = false;
                        scope.associations = response;
                        if (response != null && response.length == 1) {
                            scope.selectedAssociation = response[0];
                            if (scope.ngModel != null) {
                                scope.ngModel.associationNumber = response[0].id;
                            }
                            scope.departments = response[0].children;
                            if (scope.ngModel != null && scope.departments != null && scope.departments.length == 1) {
                                scope.ngModel.departmentNumber = scope.departments[0].id;
                            }
                        }
                    }, () => { });
                };

                scope.loadOrganizations();

                scope.getAssociationName = function (AssociationNumber: string) {
                    if (AssociationNumber != null) {
                        if (scope.associations == null) {
                            return null;
                        }
                        else {
                            var organization = scope.associations.filter(c => c.number == AssociationNumber);
                            if (organization != null && organization.length > 0) {
                                return organization[0].name;
                            }
                        }
                    }
                    return null;
                }
            };
        }

        public static Factory() {
            var directive = (fileService: FileService, $sce: ng.ISCEService, organizationService: OrganizationService, organizationSettingsService: OrganizationSettingsService) => {
                return new MapPinDirective(fileService, $sce, organizationService, organizationSettingsService);
            };

            directive['$inject'] = ['FileService', '$sce', 'OrganizationService', 'OrganizationSettingsService'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('mapPin', MapPinDirective.Factory());
}